// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NORYX sidebar theme */
.main-sidebar {
  --nx-bg: #0a0f12;
  --nx-bg-hover: #151c21;
  --nx-border: #1f2a30;
  --nx-text: #b6c1c7;
  --nx-green: #2fb344;
  background: var(--nx-bg) !important;
  border-right: 1px solid var(--nx-border);
}

/* Brand */
.main-sidebar .brand-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--nx-border) !important;
  background: transparent;
}
.main-sidebar .brand-link .brand-image {
  float: none;
  margin: 0;
  width: 36px;
  height: 36px;
  max-height: 36px;
  border-radius: 10px;
  object-fit: contain;
  box-shadow: none !important;
}
.main-sidebar .brand-link .brand-text {
  color: #fff;
  font-weight: 800 !important;
  letter-spacing: 3px;
  font-size: 1.25rem;
}

/* Scroll */
.main-sidebar .sidebar {
  padding: 8px 10px;
  scrollbar-width: thin;
  scrollbar-color: #2a343b transparent;
}
.main-sidebar .sidebar::-webkit-scrollbar { width: 6px; }
.main-sidebar .sidebar::-webkit-scrollbar-thumb {
  background: #2a343b;
  border-radius: 3px;
}

/* Items */
.main-sidebar .nav-sidebar > .nav-item { margin-bottom: 2px; }
.main-sidebar .nav-sidebar .nav-link {
  color: var(--nx-text);
  border-radius: 8px;
  padding: 9px 12px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.main-sidebar .nav-sidebar .nav-link p { font-size: 0.93rem; }
.main-sidebar .nav-sidebar .nav-link:hover,
.main-sidebar .nav-sidebar .nav-link:focus {
  background: var(--nx-bg-hover);
  color: #fff;
}
.main-sidebar .nav-sidebar .nav-link.active,
.main-sidebar .nav-sidebar > .nav-item.menu-open > .nav-link {
  background: rgba(47, 179, 68, 0.14);
  color: #fff;
}
.main-sidebar .nav-sidebar .nav-link.active .nav-icon,
.main-sidebar .nav-sidebar > .nav-item.menu-open > .nav-link .nav-icon {
  color: var(--nx-green);
}
.main-sidebar .nav-sidebar > .nav-item > .nav-link > .nav-icon {
  color: #7e8c94;
  width: 1.6rem;
  margin-right: 6px;
  font-size: 1rem;
}
.main-sidebar .nav-sidebar > .nav-item > .nav-link:hover > .nav-icon {
  color: var(--nx-green);
}
.main-sidebar .nav-sidebar .nav-link .right {
  color: #6b7a82;
  transition: transform 0.2s ease;
}

/* Sub menus */
.main-sidebar .nav-treeview {
  margin: 2px 0 6px 18px;
  padding-left: 6px;
  border-left: 1px solid var(--nx-border);
}
.main-sidebar .nav-treeview > .nav-item > .nav-link {
  padding: 7px 10px;
  font-size: 0.88rem;
}
.main-sidebar .nav-treeview .nav-icon {
  font-size: 0.5rem;
  width: 1.2rem;
  color: #55646c;
}
.main-sidebar .nav-treeview .nav-link:hover .nav-icon,
.main-sidebar .nav-treeview .nav-link.active .nav-icon {
  color: var(--nx-green);
}
`, "",{"version":3,"sources":["webpack://./src/components/layouts/MenuNoryx.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oDAAoD;EACpD,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;AACtC;AACA,4CAA4C,UAAU,EAAE;AACxD;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,UAAU;AACV,yCAAyC,kBAAkB,EAAE;AAC7D;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mDAAmD;AACrD;AACA,yCAAyC,kBAAkB,EAAE;AAC7D;;EAEE,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,mCAAmC;EACnC,WAAW;AACb;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,sBAAsB;AACxB","sourcesContent":["/* NORYX sidebar theme */\n.main-sidebar {\n  --nx-bg: #0a0f12;\n  --nx-bg-hover: #151c21;\n  --nx-border: #1f2a30;\n  --nx-text: #b6c1c7;\n  --nx-green: #2fb344;\n  background: var(--nx-bg) !important;\n  border-right: 1px solid var(--nx-border);\n}\n\n/* Brand */\n.main-sidebar .brand-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--nx-border) !important;\n  background: transparent;\n}\n.main-sidebar .brand-link .brand-image {\n  float: none;\n  margin: 0;\n  width: 36px;\n  height: 36px;\n  max-height: 36px;\n  border-radius: 10px;\n  object-fit: contain;\n  box-shadow: none !important;\n}\n.main-sidebar .brand-link .brand-text {\n  color: #fff;\n  font-weight: 800 !important;\n  letter-spacing: 3px;\n  font-size: 1.25rem;\n}\n\n/* Scroll */\n.main-sidebar .sidebar {\n  padding: 8px 10px;\n  scrollbar-width: thin;\n  scrollbar-color: #2a343b transparent;\n}\n.main-sidebar .sidebar::-webkit-scrollbar { width: 6px; }\n.main-sidebar .sidebar::-webkit-scrollbar-thumb {\n  background: #2a343b;\n  border-radius: 3px;\n}\n\n/* Items */\n.main-sidebar .nav-sidebar > .nav-item { margin-bottom: 2px; }\n.main-sidebar .nav-sidebar .nav-link {\n  color: var(--nx-text);\n  border-radius: 8px;\n  padding: 9px 12px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.main-sidebar .nav-sidebar .nav-link p { font-size: 0.93rem; }\n.main-sidebar .nav-sidebar .nav-link:hover,\n.main-sidebar .nav-sidebar .nav-link:focus {\n  background: var(--nx-bg-hover);\n  color: #fff;\n}\n.main-sidebar .nav-sidebar .nav-link.active,\n.main-sidebar .nav-sidebar > .nav-item.menu-open > .nav-link {\n  background: rgba(47, 179, 68, 0.14);\n  color: #fff;\n}\n.main-sidebar .nav-sidebar .nav-link.active .nav-icon,\n.main-sidebar .nav-sidebar > .nav-item.menu-open > .nav-link .nav-icon {\n  color: var(--nx-green);\n}\n.main-sidebar .nav-sidebar > .nav-item > .nav-link > .nav-icon {\n  color: #7e8c94;\n  width: 1.6rem;\n  margin-right: 6px;\n  font-size: 1rem;\n}\n.main-sidebar .nav-sidebar > .nav-item > .nav-link:hover > .nav-icon {\n  color: var(--nx-green);\n}\n.main-sidebar .nav-sidebar .nav-link .right {\n  color: #6b7a82;\n  transition: transform 0.2s ease;\n}\n\n/* Sub menus */\n.main-sidebar .nav-treeview {\n  margin: 2px 0 6px 18px;\n  padding-left: 6px;\n  border-left: 1px solid var(--nx-border);\n}\n.main-sidebar .nav-treeview > .nav-item > .nav-link {\n  padding: 7px 10px;\n  font-size: 0.88rem;\n}\n.main-sidebar .nav-treeview .nav-icon {\n  font-size: 0.5rem;\n  width: 1.2rem;\n  color: #55646c;\n}\n.main-sidebar .nav-treeview .nav-link:hover .nav-icon,\n.main-sidebar .nav-treeview .nav-link.active .nav-icon {\n  color: var(--nx-green);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
